module.exports = __webpack_public_path__ + "static/media/document-preview-1.6153aaa5.jpg";